import { createStore } from "redux";

const initialState = {
  sidebarShow: "responsive",
};

const changeState = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case "set":
      return { ...state, ...rest };
    default:
      return state;
  }
};

const store = createStore(changeState);
export default store;

// import { applyMiddleware, compose, createStore } from "redux";
// // import { routerMiddleware } from "connected-react-router";
// import thunk from "redux-thunk";
// import rootReducer from "./reducers/index";
// import { composeWithDevTools } from 'redux-devtools-extension'

// const devTools =
//   process.env.NODE_ENV === "development"
//     ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ &&
//       window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__()
//     : null;

// const createAppStore = (initialState, history) => {
//   return createStore(
//     rootReducer(history),

//     initialState,
//     process.env.NODE_ENV === "development"
//       ? compose(applyMiddleware(thunk, routerMiddleware(history)), devTools)
//       : compose(applyMiddleware(thunk, routerMiddleware(history)))
//   );
// };

// const createAppStore = createStore(
//   rootReducer(),
//   composeWithDevTools(applyMiddleware( thunk))
// )

// export default createAppStore;
